// App-wide configuration constants

export const SIDEBAR_PAST_GATHERINGS_DAYS = 3;

// Contact emails
export const EMAIL_PRIVACY = 'support@cactusnorms.com';
export const EMAIL_GDPR = 'support@cactusnorms.com';